import { call, put, takeEvery } from 'redux-saga/effects';
import { getUsers, countAllUsers } from '../../requests/users_request';
import { users_actions } from '../actions/users.actions';
import { GET_USERS_REQUEST } from '../constants/users.constants';
import { message_error } from '../../../../../components/Message';

function* getUsersRequest({ filters, init }) {
    const { result, error, options } = yield call(getUsers, filters, init);

    const allUsersCount = yield call(countAllUsers, filters, init);
    const usersData = {
        users: options,
        allUsersCount: allUsersCount.amount || 0,
    };

    if (result) {
        yield put(users_actions.getUsersRequestSuccess(usersData));
    } else {
        yield put(users_actions.getUsersRequestFailure(error));
        message_error(error);
    }
}

export default function* usersSaga() {
    yield takeEvery(GET_USERS_REQUEST, getUsersRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_list/redux/sagas/users.saga.js